import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { BackofficeJobSearchQuerySchema, BackofficeJobSearchResultSchema } from "schema"
import { z } from "zod"

export type BackofficeJobSearchResult = z.infer<typeof BackofficeJobSearchResultSchema>[number]

export type BackofficeJobSearchQuery = z.input<typeof BackofficeJobSearchQuerySchema>

type Query = BackofficeJobSearchQuery

type Props = {
  query: Query
  enabled?: boolean
}

export const getBackofficeJobSearchQuery = ({ query, enabled = true }: Props) =>
  queryOptions({
    queryKey: ["backofficeJobSearch", query],
    enabled,
    queryFn: async () => {
      const { data } = await axios.get<{ data: BackofficeJobSearchResult[] }>(
        "/backoffice/jobSearch",
        { params: query },
      )
      return BackofficeJobSearchResultSchema.parse(data.data)
    },
  })
